import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import { Link, Stack, Typography } from '@mui/material';
import React, { memo, useEffect, useMemo, useRef, useState } from 'react';
import theme from '../../../../../theme';
import { Dashboard } from '../../../../../types/files';
import CommentaryModal from '../../../../modals/tables/dashboards/rows/CommentaryModal';
import useStyles from "../styles";

const edjsParser = require("editorjs-parser").default;
const parser = new edjsParser();

const CommentaryCell: React.FC<{ dashboard: Dashboard }> = ({ dashboard }) => {
    const classes = useStyles();
    const [commentaryModalOpen, setCommentaryModalOpen] = useState<boolean>(false);
    const [commentaryNote, setCommentaryNote] = useState<string>('');
    const latestUpdateRef = useRef<HTMLElement>(null);

    const commentary = useMemo(() =>
        dashboard?.notes?.find(note => note.title === `$['Commentary']`)
        , [dashboard?.notes]);

    useEffect(() => {
        setCommentaryNote(new DOMParser().parseFromString(parser.parse({ blocks: (JSON.parse(commentary?.data || '[]') as any[]).slice(1) }), 'text/html')?.body?.textContent?.trim() || '');
    }, [commentary]);

    return (<>
        <Stack width="100%" ref={latestUpdateRef}>
            {!!commentaryNote.length ? (
                <Stack direction="row" alignItems="center" justifyContent="space-between" width="100%"
                    onClick={() => setCommentaryModalOpen(true)}
                    sx={{
                        border: `1px solid ${theme.colors.neutral['200']}`,
                        borderRadius: '6px',
                        cursor: 'pointer',
                        '&:hover': { backgroundColor: theme.colors.neutral['50'] },
                    }}>
                    <Stack direction="row" spacing={1} alignItems="center" sx={{ minWidth: 0 }}>
                        <ChatBubbleOutlineIcon sx={{
                            width: 30, height: 30, flexShrink: 0,
                            color: '#4aab96',
                            backgroundColor: '#e8f5f3',
                            borderRadius: '6px',
                            padding: '5px',
                            boxSizing: 'border-box',
                        }} />
                        <Typography className={classes.url} sx={{ minWidth: 0 }}>
                            {commentaryNote.replace(/^Commentary:\s*/i, '')}
                        </Typography>
                    </Stack>
                    <ExpandMoreIcon className={classes.icon} sx={{ fill: theme.colors.neutral['400'], flexShrink: 0 }} />
                </Stack>
            ) : (
                <Stack direction="row" spacing={1} alignItems="center" justifyContent="flex-start">
                    <Link fontFamily="Lato" fontSize="0.9rem" fontWeight={500}
                        color={`${theme.colors.neutral['500']} !important`}
                        underline='hover'
                        onClick={() => setCommentaryModalOpen(true)}
                        sx={{ cursor: 'pointer' }}>
                        {'Add context...'}
                    </Link>
                </Stack>
            )}
        </Stack>
        {commentaryModalOpen && (
            <CommentaryModal
                open={commentaryModalOpen}
                dashboard={dashboard}
                newCommentary={!commentaryNote.length}
                anchorElement={latestUpdateRef.current}
                onClose={() => setCommentaryModalOpen(false)} />
        )}
    </>);
}

export default memo(CommentaryCell);
